import { getCarBrandSvg, CAR_BRAND_SVG_DEFAULT } from "libraries/svgPaths";

type Props = {
  carBrand: string;
  size?: "small" | "large" | "full";
};

const LOGO_SIZE_LIMIT = 75;
const LOGO_SIZE_LARGE = 45;
const LOGO_SIZE_SMALL = 20;

export const sizeToPixel = (size?: "small" | "large"): number =>
  size === "large"
    ? LOGO_SIZE_LARGE
    : size === "small"
    ? LOGO_SIZE_SMALL
    : LOGO_SIZE_SMALL;

const CarLogoBrand = ({ carBrand, size }: Props) => (
  <img
    alt="brand-logo"
    style={{
      width: size === "full" ? undefined : sizeToPixel(size),
      height: size === "full" ? undefined : sizeToPixel(size),
      maxWidth: LOGO_SIZE_LIMIT,
      maxHeight: LOGO_SIZE_LIMIT,
    }}
    src={getCarBrandSvg(carBrand)}
    onError={({ currentTarget }) => {
      currentTarget.onerror = null; // prevents looping
      currentTarget.src = CAR_BRAND_SVG_DEFAULT;
    }}
  />
);

export default CarLogoBrand;
